module.exports = __webpack_public_path__ + "media/honey-icons/icon-wifi-locked-full-8a7eba8a.svg";